export default {
  name: 'نام',
  fileSize: 'حجم فایل',
  download: 'دانلود',
  copyLink: 'کپی لینک دانلود',
  copied: 'کپی شد',
  uploadDate: 'تاریخ ایجاد',
  documentContentPermanentlyRemoved:
    'محتوای این سند پاک شده است و قابل بازیابی نیست',
  creatorUser: 'کاربر: ',
  updateDate: 'آخرین به روز رسانی',
  unknownFormatName: 'نامعلوم',
  versionName: 'عنوان نسخه: ',
  versionMessage: 'توضیح نسخه: ',
  documentHistory: 'تاریخچه سند',
  invalidFile: 'فایل نا معتبر است',
  send: 'ارسال',
  addVersion: 'بارگذاری نسخه جدید',
  view: 'نمایش',
  setActive: 'ثبت نسخه فعال',
  deleteVersion: 'حذف نسخه',
  versionDate: 'تاریخ نسخه',
  selectFile: 'انتخاب سند',
  confirmRemoveVersion: 'ایا مطمئن هستید که می خواهید این نسخه حذف شود؟',
  changeWillBeLost:
    'تغییرات شما هنوز ذخیره نشده است. ایا از بستن این صفحه مطمئن هستید؟',
  versionUpdated: 'نسخه جدید بارگذاری شد',
  processing: 'در حال پردازش',
  loaded: 'بارگذاری شد',
  pleaseSelectScribeHowHtml: 'لطفا فایل HTML اسکرایب را انتخاب کنید',
  pleaseSelectScribeHowAssets: 'لطفا اسناد ضمیمه اسکرایب را ضمیمه کنید',

  unknownFormat(format: string) {
    return `امکان نمایش سند با فرمت ${format} وجود ندارد لطفا سند را دانلود کرده و آن را مشاهده کنید. `;
  },
};
